import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue-select/dist/vue-select.css';

import Vue, {CreateElement} from 'vue';
import {App as InertiaApp, plugin as InertiaPlugin} from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
import {InertiaProgress} from '@inertiajs/progress'
import VueSweetalert2 from 'vue-sweetalert2';
import {ZiggyVue} from 'ziggy-vue';

import '@/utils/font-awesome-setup';

import YesNoDetailsInput from '@/Components/Input/YesNoDetailsInput.vue';
import YesNoNumberInput from '@/Components/Input/YesNoNumberInput.vue';
import OptsWithOtherInput from '@/Components/Input/OptsWithOtherInput.vue';
import CheckboxWithOtherInput from '@/Components/Input/CheckboxWithOtherInput.vue';
import WrappedUpload from '@/Components/Input/WrappedUploadInput.vue';
import YesNoOtherInput from '@/Components/Input/YesNoOtherInput.vue';
import DocumentationInput from '@/Components/Input/DocumentationInput.vue';
import YesNoInput from '@/Components/Input/YesNoInput.vue';
import YesNoNaInput from '@/Components/Input/YesNoNaInput.vue';
import YesNoNaDetailsInput from '@/Components/Input/YesNoNaDetailsInput.vue';
import YesNoUnsureInput from '@/Components/Input/YesNoUnsureInput.vue';
import YesNoUnsureDetailsInput from '@/Components/Input/YesNoUnsureDetailsInput.vue';
import FinancialNumberInput from '@/Components/Input/FinancialNumberInput.vue';
import FaCheckboxComponent from '@/Components/FaCheckboxComponent.vue';
import FaRadioComponent from '@/Components/FaRadioComponent.vue';
import FaFincialNumber from '@/Components/FaFincialNumber.vue';

import '@/Plugins/vue-formulate';
import '@/Plugins/vue-data-tables';

// @ts-ignore
import Transitions from 'vue2-transitions'
import VueMeta from 'vue-meta';
const { route } = window;

Vue.component(YesNoInput.COMPONENT_NAME, YesNoInput);
Vue.component(YesNoNaInput.COMPONENT_NAME, YesNoNaInput);
Vue.component(YesNoNaDetailsInput.COMPONENT_NAME, YesNoNaDetailsInput);
Vue.component(YesNoUnsureInput.COMPONENT_NAME, YesNoUnsureInput);
Vue.component(YesNoUnsureDetailsInput.COMPONENT_NAME, YesNoUnsureDetailsInput);
Vue.component(YesNoDetailsInput.COMPONENT_NAME, YesNoDetailsInput);
Vue.component(YesNoOtherInput.COMPONENT_NAME, YesNoOtherInput);
Vue.component(YesNoNumberInput.COMPONENT_NAME, YesNoNumberInput);
Vue.component(OptsWithOtherInput.COMPONENT_NAME, OptsWithOtherInput);
Vue.component(CheckboxWithOtherInput.COMPONENT_NAME, CheckboxWithOtherInput);
Vue.component(WrappedUpload.COMPONENT_NAME, WrappedUpload);
Vue.component(DocumentationInput.COMPONENT_NAME, DocumentationInput);
Vue.component(FinancialNumberInput.COMPONENT_NAME, FinancialNumberInput);

Vue.component(FaCheckboxComponent.COMPONENT_NAME, FaCheckboxComponent);
Vue.component(FaRadioComponent.COMPONENT_NAME, FaRadioComponent);
Vue.component(FaFincialNumber.COMPONENT_NAME, FaFincialNumber);
Vue.mixin({methods: {route}});
Vue.use(Transitions)
Vue.use(InertiaPlugin);
Vue.use(VueSweetalert2);
Vue.use(PortalVue);
Vue.use(ZiggyVue);
Vue.use(VueMeta);

InertiaProgress.init({
    showSpinner: true

})

const app = document.getElementById('app');

if (app) {
    new Vue({
        render: (h: CreateElement) =>
            h(InertiaApp, {
                props: {
                    initialPage: JSON.parse(<string>app.dataset.page),
                    resolveComponent: (name: string) => require(`@/Pages/${name}`).default,
                },
            }),
    }).$mount(app);
}
